import { Link, useLocation, useParams } from "react-router-dom";
import { Check, Home as HomeIcon, Mail } from "lucide-react";

export default function GutscheinDanke() {
  const { orderNumber } = useParams();
  const location = useLocation();
  const order = location.state?.order || null;

  return (
    <div className="min-h-screen bg-[#F5EFE3] pt-16 pb-24 px-6" data-testid="voucher-thanks-page">
      <div className="max-w-2xl mx-auto">
        {/* Erfolg-Header */}
        <div className="text-center mb-12">
          <div className="w-16 h-16 mx-auto mb-6 border-2 border-[#D68A64] rounded-full flex items-center justify-center">
            <Check className="text-[#D68A64]" size={28} />
          </div>
          <div className="text-xs tracking-[0.25em] uppercase text-[#8A7A68] mb-3">
            Bestellung eingegangen
          </div>
          <h1 className="font-serif text-4xl md:text-5xl text-[#2C2A26] mb-6">
            Vielen Dank.
          </h1>
          <p className="text-[#5C574E] font-light leading-relaxed max-w-lg mx-auto">
            Ihre Bestellung ist bei mir eingegangen. Sie erhalten in wenigen Minuten
            eine Bestätigungs-E-Mail mit allen Zahlungsdetails.
          </p>
        </div>

        {/* Gutscheinnummer */}
        <div className="bg-[#FBF7EC] border border-[#E3DECE] p-8 mb-8" data-testid="voucher-order-info">
          <div className="text-xs tracking-[0.25em] uppercase text-[#8A7A68] mb-2">
            Ihre Gutscheinnummer
          </div>
          <div className="font-mono text-2xl md:text-3xl text-[#D68A64] font-bold" data-testid="voucher-order-number">
            {orderNumber}
          </div>
          {order && (
            <>
              <div className="text-xs tracking-[0.25em] uppercase text-[#8A7A68] mt-6 mb-2">
                Guthaben
              </div>
              <div className="font-serif text-2xl text-[#2C2A26]">
                {Number(order.amount_eur).toFixed(2)} €
              </div>
              <p className="text-xs text-[#8A7A68] italic mt-2">
                Wird bei Einlösung von der Endrechnung des Menü-Einsatzes abgezogen.
              </p>
            </>
          )}
        </div>

        {/* Zahlungshinweis */}
        <div className="border border-[#D68A64] bg-white p-8 mb-8">
          <h3 className="font-serif text-xl text-[#2C2A26] mb-4">So geht es weiter</h3>
          <ol className="space-y-4 text-sm text-[#5C574E]">
            <li className="flex gap-4">
              <span className="font-serif italic text-2xl text-[#D68A64] leading-none">1.</span>
              <div>
                <b className="text-[#2C2A26]">Bestätigungs-E-Mail prüfen.</b>
                <br />Sie erhalten die Rechnung mit meiner IBAN und dem Verwendungszweck
                <span className="font-mono text-[#D68A64]"> {orderNumber}</span>.
              </div>
            </li>
            <li className="flex gap-4">
              <span className="font-serif italic text-2xl text-[#D68A64] leading-none">2.</span>
              <div>
                <b className="text-[#2C2A26]">Überweisen.</b>
                <br />Bitte den Verwendungszweck exakt so angeben — sonst kann ich die
                Zahlung nicht zuordnen.
              </div>
            </li>
            <li className="flex gap-4">
              <span className="font-serif italic text-2xl text-[#D68A64] leading-none">3.</span>
              <div>
                <b className="text-[#2C2A26]">Der Brief kommt.</b>
                <br />Nach Zahlungseingang fülle ich Ihren Gutschein handschriftlich aus,
                versiegle ihn mit einem Wachssiegel und verschicke ihn per Post.
                Zustellzeit ca. 10–14 Werktage.
              </div>
            </li>
          </ol>
        </div>

        {/* Kontakt */}
        <div className="text-center text-sm text-[#8A7A68]">
          <p className="mb-4">
            Fragen oder Änderungswunsch zur Bestellung?
          </p>
          <a
            href={`mailto:mietkoch@stutz-cuisine.com?subject=Gutschein-Bestellung ${orderNumber}`}
            className="inline-flex items-center gap-2 text-[#D68A64] hover:underline"
            data-testid="voucher-contact-link"
          >
            <Mail size={16} /> mietkoch@stutz-cuisine.com
          </a>
        </div>

        {/* Home Link */}
        <div className="text-center mt-16 pt-8 border-t border-[#E3DECE]">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm tracking-[0.2em] uppercase text-[#8A7A68] hover:text-[#D68A64]"
          >
            <HomeIcon size={14} /> Zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
